import React from "react";
import "./index.less";

class ChargingVoucherRules extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }
    render() {
        return (
            <div className="page_type_h5">
                <div id="ChargingVoucherRules">
                    <section>
                        1、绿色慧联平台发放的商品优惠券（如充电券、租车券等）仅能在指定的商品或服务上使用，用于结算订单时抵减应支付商品金额，不能进行兑现或其他用途。
                        <br />
                        2、优惠券的有效期限：优惠券必须在规定的有效期内使用，过期作废。
                        <br />
                        3、充电券的使用方法：
                        <br />
                        （1）充电时自动充满结束后优惠券将自动进行抵扣，抵扣逻辑以金额为优先，即金额越大的越优先自动抵扣；金额一致时，失效时间越近，则越优先抵扣。
                        <br />
                        （2）如果不希望结算时自动抵扣充电券，请于”我的-优惠券-自动使用设置“关闭按钮即可。
                        <br />
                        （3）此外，用户手动结束充电时可自主选择优惠券进行结算抵扣，注意需在充满电自动跳枪前自主结束充电才可以人工选择相应的优惠券。
                        <br />
                        4、使用限制：每张优惠券只能使用一次，且每个订单只能使用一张优惠券，不能叠加使用。
                        <br />
                        5、优惠券面额限制：优惠券的抵扣金额不得超过其面值，且订单金额需满足优惠券规定的最低消费金额。
                        <br />
                        6、折扣限制：优惠券分为无门槛券、满减券、折扣券等多种类型，优惠券的抵扣金额可能存在上限或下限，部分商品可能无法使用优惠券，请以具体优惠券的要求为准。
                        <br />
                        7、退换货限制：如果使用优惠券的商品或服务退货，优惠金额不退还。
                        <br />
                        8、作弊和违规：优惠券的非法洗刷或其他恶意行为一经发现，商家有权取消客户的优惠券使用资格或使用优惠券的订单。
                        <br />
                        优惠券的最终解释权归绿色慧联所有。
                    </section>
                </div>
            </div>
        );
    }
}

export default ChargingVoucherRules;



// WEBPACK FOOTER //
// ./src/staticPage/chargingVoucherRules/index.js